import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar, UserLink } from "@/components/UserBits";
import { ReactionGlyph } from "@/components/SpHeart";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export function ReactionsList({ kind, id, onClose }) {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("all");
  useEffect(() => {
    api.get(kind === "post" ? `/feed/posts/${id}/reactions` : `/feed/comments/${id}/reactions`).then(({ data }) => setD(data)).catch(() => setD({ total: 0, counts: [], users: [] }));
  }, [kind, id]);
  const shown = d ? (tab === "all" ? d.users : d.users.filter((u) => u.emoji === tab)) : [];
  const tabCls = (on) => `shrink-0 px-3 h-9 rounded-full text-sm font-bold transition-colors ${on ? "pink-gradient text-white" : "bg-rose-50/60 text-slate-600 hover:bg-rose-50"}`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm rounded-3xl p-4 sm:p-5" data-testid="reactions-list">
        <DialogTitle className="font-bold">Reaktionen</DialogTitle>
        {!d ? <Loader2 className="w-5 h-5 animate-spin text-rose-500 mx-auto my-6" /> : (
          <>
            <div className="flex gap-1.5 overflow-x-auto no-scrollbar pb-1">
              <button onClick={() => setTab("all")} data-testid="reactions-tab-all" className={tabCls(tab === "all")}>Alle {d.total}</button>
              {d.counts.map(([e, n]) => <button key={e} onClick={() => setTab(e)} data-testid={`reactions-tab-${e}`} className={`${tabCls(tab === e)} inline-flex items-center gap-1`}><ReactionGlyph e={e} className="w-5 h-5" /> {n}</button>)}
            </div>
            <ul className="max-h-[55dvh] overflow-y-auto space-y-1 -mx-1 px-1">
              {shown.map((u) => (
                <li key={u.user_id} className="flex items-center gap-3 py-1.5" data-testid={`reactions-user-${u.user_id}`}>
                  <span className="relative">
                    <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-10 h-10" />
                    <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-white shadow flex items-center justify-center text-xs"><ReactionGlyph e={u.emoji} className="w-4 h-4" /></span>
                  </span>
                  <UserLink id={u.user_id} className="flex-1 min-w-0 truncate font-semibold text-sm">{u.name}{u.is_me && <span className="text-slate-400 font-normal"> (du)</span>}</UserLink>
                </li>
              ))}
              {shown.length === 0 && <li className="text-sm text-slate-400 py-4 text-center">Noch keine Reaktionen</li>}
            </ul>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
